module.exports = __webpack_public_path__ + "img/hdi_new.a9aa8137.svg";